// src/services/emisionDTEService.js
import { apiClient } from './api';

export const TIPOS_DTE = [
  { codigo: 33,  nombre: 'Factura Electrónica' },
  { codigo: 34,  nombre: 'Factura Electrónica Exenta' },
  { codigo: 39,  nombre: 'Boleta Electrónica' },
  { codigo: 41,  nombre: 'Boleta Electrónica Exenta' },
  { codigo: 46,  nombre: 'Factura de Compra Electrónica' },
  { codigo: 52,  nombre: 'Guía de Despacho Electrónica' },
  { codigo: 56,  nombre: 'Nota de Débito Electrónica' },
  { codigo: 61,  nombre: 'Nota de Crédito Electrónica' },
  { codigo: 110, nombre: 'Factura de Exportación Electrónica' },
];

export const emisionDTEService = {

  // ── CAF ───────────────────────────────────────────────────────────────────

  async uploadCaf(rutEmpresa, cafFile, ambiente = 'certificacion') {
    const formData = new FormData();
    formData.append('rut_empresa', rutEmpresa);
    formData.append('ambiente', ambiente);
    formData.append('caf_file', cafFile, cafFile.name);
    return apiClient.uploadFile('/emision/caf/upload', formData);
  },

  async listarCafs(rutEmpresa) {
    return apiClient.get(`/emision/caf/${rutEmpresa}`);
  },

  async desactivarCaf(cafId) {
    return apiClient.delete(`/emision/caf/${cafId}`);
  },

  // ── Emitir DTE ────────────────────────────────────────────────────────────

  async emitirDTE(data) {
    return apiClient.post('/emision/emitir', data);
  },

  // ── Documentos emitidos ───────────────────────────────────────────────────

  async listarDocumentos(rutEmpresa, { ambiente, tipoDte, periodo, estadoSii } = {}) {
    const params = new URLSearchParams();
    if (ambiente) params.append('ambiente', ambiente);
    if (tipoDte) params.append('tipo_dte', tipoDte);
    if (periodo) params.append('periodo', periodo);
    if (estadoSii) params.append('estado_sii', estadoSii);
    const qs = params.toString();
    return apiClient.get(`/emision/documentos/${rutEmpresa}${qs ? `?${qs}` : ''}`);
  },

  async consultarEstadoEnvio(dteId) {
    return apiClient.post(`/emision/documentos/${dteId}/estado-envio`, {});
  },

  async consultarEstadoDte(dteId) {
    return apiClient.post(`/emision/documentos/${dteId}/estado-dte`, {});
  },

  // ── Estado manual ─────────────────────────────────────────────────────────

  async consultarEstado(data) {
    return apiClient.post('/emision/estado', data);
  },

  // ── Folios disponibles ────────────────────────────────────────────────────

  async foliosDisponibles(rutEmpresa) {
    return apiClient.get(`/emision/folios-disponibles?rut_empresa=${rutEmpresa}`);
  },

  async detalleFolios(rutEmpresa, tipoDte) {
    return apiClient.get(`/emision/folios/${rutEmpresa}/${tipoDte}`);
  },

  async liberarFolio(rutEmpresa, tipoDte, folio) {
    return apiClient.delete(`/emision/folios/${rutEmpresa}/${tipoDte}/${folio}`);
  },
};
